"use strict"

import angular from "angular"

export class ApiNotificationComponent {
  /*@ngInject*/
  constructor($scope, $timeout) {
    this.$scope = $scope
    this.$timeout = $timeout
    this.showMessage = false
    this.message = ""
    this.type = "warning" // 'warning' for rate limits, 'error' for server errors, 'info' for retries
    this.activeSessions = 0
    this.maxSessions = 0
    this.title = ""
  }

  $onInit() {
    // Listen for rate limit events from the interceptor
    this.$scope.$on("gemapark-rate-limit", (event, data) => {
      this.showNotification({
        title: "System Busy",
        message: data.message || "Sorry the system is very busy just now, please try again later",
        type: "warning",
        activeSessions: data.activeSessions || 0,
        maxSessions: data.maxSessions || 20,
      })
    })

    // Listen for generic API error events
    this.$scope.$on("api-error", (event, data) => {
      this.showNotification({
        title: data.title || "Request Failed",
        message: data.message || "Sorry, something went wrong. Please try again.",
        type: data.type || "error",
      })
    })
  }

  showNotification({ title, message, type, activeSessions, maxSessions }) {
    this.title = title
    this.message = message
    this.type = type
    this.activeSessions = activeSessions || 0
    this.maxSessions = maxSessions || 0
    this.showMessage = true

    // Auto-hide after 10 seconds for non-retry errors
    if (type !== "info") {
      this.$timeout(() => {
        this.hideMessage()
      }, 10000)
    }
  }

  hideMessage() {
    this.showMessage = false
    this.message = ""
    this.title = ""
  }

  retry() {
    this.hideMessage()
  }
}

export default angular
  .module("components.rateLimitMessage", [])
  .component("rateLimitMessage", {
    template: require("./rateLimitMessage.html"),
    controller: ApiNotificationComponent,
    bindings: {},
  })
  .name
